<template>
  <ul class="base-bottom-sheet__menu">
    <li v-if="contact.email">
      <a :href="`mailto:${contact.email}`" @click="$emit('done')">
        <BaseIcon name="mail" />
        <span class="contact-ways__value">{{ contact.email }}</span>
      </a>
    </li>
    <li v-if="contact.email">
      <button type="button" @click="copyEmail">
        <BaseIcon name="copy" />
        {{ $t('page.contact-directory.phone-list.copy-email') }}
      </button>
    </li>
    <li v-if="contact.telephone">
      <a :href="`tel:${dialable(contact.telephone)}`" @click="$emit('done')">
        <BaseIcon name="phone" />
        <span class="contact-ways__value">{{ contact.telephone }}</span>
      </a>
    </li>
    <li v-if="contact.url">
      <a :href="withScheme(contact.url)" target="_blank" rel="noopener noreferrer" @click="$emit('done')">
        <BaseIcon name="link" />
        <span class="contact-ways__value">{{ contact.url }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import { copyTextToClipboard } from '@/util/clipboard';

// The phone links to reach a contact: write, call, open their page. Each is an action that
// closes the sheet (`done`).
export default {
  name: 'ContactWays',
  components: { BaseIcon },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // The number to dial: an extension ("poste 12", "ext. 12") is for the person answering.
    dialable(telephone) {
      return telephone.split(/poste|ext\.?|#/i)[0].replace(/[^\d+]/g, '');
    },
    withScheme(url) {
      return /^https?:\/\//i.test(url) ? url : `https://${url}`;
    },
    // Through the app's helper: on a page served without HTTPS (a phone on the dev server) the
    // browser has no clipboard API and the helper falls back on the older copy command.
    copyEmail() {
      copyTextToClipboard(
        this.contact.email,
        () => this.$toast.success(this.$t('page.contact-directory.phone-list.email-copied')),
        () => this.$toast.error(this.$t('page.analysis.text-selection.copy.error')),
      );
      this.$emit('done');
    },
  },
};
</script>

<style lang="scss">
.contact-ways__value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
